// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-tab-issue-point {
  padding: 5px;
  height: 100%;
  background-color: var(--background-color-4);
}

.DPU-tabs-container {
  display: flex;
  flex-wrap: wrap;

  /* background: #e5e5e5; */
}
.DPU-input-tabs-issue {
  position: absolute;
  opacity: 0;
}
.DPU-label-header-tab-issue {
  width: auto;
  padding: 5px 10px;
  background: #e5e5e5;
  cursor: pointer;
  font-weight: bold;
  color: #7f7f7f;
  transition: background 0.1s, color 0.1s;
}
.DPU-label-header-tab-issue:hover {
  background: #d8d8d8;
}
.DPU-label-header-tab-issue:active {
  background: #ccc;
}
.DPU-input-tabs-issue:focus + .DPU-label-header-tab-issue {
  z-index: 1;
}
.DPU-input-tabs-issue:checked + .DPU-label-header-tab-issue {
  background: #fff;
  color: #000;
  border-bottom: 3px solid var(--primary-color-1);
}

.DPU-panel-container {
  width: 100%;
  display: none;
  order: 99;
  padding: 0 5px;
  border-top: 1px solid #ccc;
}

.DPU-input-tabs-issue:checked
  + .DPU-label-header-tab-issue
  + .DPU-panel-container {
  display: block;
}

.DPU-container-group-btn-iusse {
  display: flex;
  width: 100%;
  margin-left: auto;
  justify-content: flex-end;
}
.DPU-container-group-btn-iusse .DPU-btn-defaut-style {
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/issuePoint/issuePoint.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;;EAEf,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".container-tab-issue-point {\r\n  padding: 5px;\r\n  height: 100%;\r\n  background-color: var(--background-color-4);\r\n}\r\n\r\n.DPU-tabs-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n\r\n  /* background: #e5e5e5; */\r\n}\r\n.DPU-input-tabs-issue {\r\n  position: absolute;\r\n  opacity: 0;\r\n}\r\n.DPU-label-header-tab-issue {\r\n  width: auto;\r\n  padding: 5px 10px;\r\n  background: #e5e5e5;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  color: #7f7f7f;\r\n  transition: background 0.1s, color 0.1s;\r\n}\r\n.DPU-label-header-tab-issue:hover {\r\n  background: #d8d8d8;\r\n}\r\n.DPU-label-header-tab-issue:active {\r\n  background: #ccc;\r\n}\r\n.DPU-input-tabs-issue:focus + .DPU-label-header-tab-issue {\r\n  z-index: 1;\r\n}\r\n.DPU-input-tabs-issue:checked + .DPU-label-header-tab-issue {\r\n  background: #fff;\r\n  color: #000;\r\n  border-bottom: 3px solid var(--primary-color-1);\r\n}\r\n\r\n.DPU-panel-container {\r\n  width: 100%;\r\n  display: none;\r\n  order: 99;\r\n  padding: 0 5px;\r\n  border-top: 1px solid #ccc;\r\n}\r\n\r\n.DPU-input-tabs-issue:checked\r\n  + .DPU-label-header-tab-issue\r\n  + .DPU-panel-container {\r\n  display: block;\r\n}\r\n\r\n.DPU-container-group-btn-iusse {\r\n  display: flex;\r\n  width: 100%;\r\n  margin-left: auto;\r\n  justify-content: flex-end;\r\n}\r\n.DPU-container-group-btn-iusse .DPU-btn-defaut-style {\r\n  margin-left: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
